import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d70ce7f6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d70ce7f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70ce7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70ce7f6')) {
      api.createRecord('d70ce7f6', component.options)
    } else {
      api.reload('d70ce7f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d70ce7f6&scoped=true&", function () {
      api.rerender('d70ce7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-fields/index.vue"
export default component.exports